import "workers/Workers";
import "sockets/Sockets";

window.DATA_LOAD_STATUS = {
    LOADING: "loading",
    ERROR: "error",
    LOADED: "loaded",
};
